import { useDashboardContext } from 'lib/context/Dashboard/DashboardContext';
import { cn } from 'lib/helpers/utility';

import ViewTabs from 'components/shared/AgTablePage/components/ViewTabs';
import Filters from 'components/shared/Filters/Filters';
import FilterActions from 'components/shared/Filters/components/FilterActions';

const AppointmentFilters = ({ noTabs = false, category = 'dashboard_calendar', className }) => {
  const {
    filters,
    setFilters,
    defaultFilters,
    initialFilters,
    isEditingFilter,
    setIsEditingFilter,
    setInitialFilters
  } = useDashboardContext();

  const items = [{ label: 'All appointments & events', value: null }];

  return (
    <div className="flex w-full flex-col justify-end">
      {!noTabs && (
        <div className="flex flex-1 gap-2 border-x-0 border-b border-t-0 border-solid border-neutral-100 px-3 py-2">
          <ViewTabs
            items={items}
            category={category}
            filters={filters}
            setFilters={setFilters}
            defaultFilters={defaultFilters}
            setIsEditingFilter={setIsEditingFilter}
            setInitialFilters={setInitialFilters}
            removeDefaults
          />
        </div>
      )}
      <div className={cn('flex flex-wrap items-end justify-between gap-2 px-3 py-2', className)}>
        {defaultFilters ? (
          <Filters defaultFilters={defaultFilters} filters={filters} setFilters={setFilters} />
        ) : (
          <div />
        )}
        <div className="flex flex-wrap items-start gap-2">
          {filters && (
            <FilterActions
              filters={filters}
              initialFilters={initialFilters}
              setFilters={setFilters}
              category={category}
              isEditingFilter={isEditingFilter}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentFilters;
